'use strict';
import template from './mx-calendar-resource.html';
import CalendarResourceCtrl from './mx-calendar-resource.controller';

angular.module('mx.SolutionBuilderAgent').component('mxCalendarResource', {
	bindings: {
		resourceId: '@',
		dayNumber: '@',
	},
	require: {
		calendar: '^^mxCalendar',
	},
	controller: CalendarResourceCtrl,
	controllerAs: 'vm',
	template: template,
});
